// src/utils/dateUtils.js

export const getMonthName = (month) => {
  const months = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];
  return months[month - 1];
};

export const getMonthAbbr = (month) => {
  const abbrs = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];
  return abbrs[month - 1];
};

// This matches your App.js logic: it depends on getDaysInMonth(month)
// because your calendar math is based on month lengths from App.js.
export const getDaysSinceJan1 = (day, month, getDaysInMonth) => {
  let days = day - 1;
  for (let m = 1; m < month; m++) {
    days += getDaysInMonth(m);
  }
  return days;
};

export const getDayName = (day, month, getDaysInMonth) => {
  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  // January 1, 2026 is a Thursday
  const daysSinceJan1 = getDaysSinceJan1(day, month, getDaysInMonth);
  const dayIndex = (3 + daysSinceJan1) % 7;
  return days[dayIndex];
};

// "Today" label depends on today's day/month from App.js, so we pass them in.
export const getMonthDay = (day, month, todayDay, todayMonth) => {
  if (day === todayDay && month === todayMonth) {
    return 'Today';
  }
  return getMonthName(month);
};
export   const getDaysInMonth = (month) => {
    const daysInMonths = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    return daysInMonths[month - 1];
  };